module.exports = __webpack_public_path__ + "img/shiptohomeoption.6ced4611.png";